import HomeImg from '~assets/home.svg';
import AppLogo from './assets/app_logo.svg';
import AppLogoInverse from './assets/app_logo_inverse.svg';
import AppLogoProsalco from './assets/app_logo_prosalco.svg';
import AppLogoSantaCruz from './assets/app_logo_santa_cruz.svg';
import { PROSALCO } from './constants/colors';
import { BASE, HOSPITAL_SANTA_CRUZ, WorkUnits } from './constants';

export const OCULUS_TENANT_COLORS = {
  base: BASE,
  astrazeneca: BASE,
  karyadb: BASE,
  cri: BASE,
  hospitalsantacruz: HOSPITAL_SANTA_CRUZ,
  prosalco: PROSALCO
};

export const OCULUS_TENANT_IMAGES = {
  base: {
    logo_regular: AppLogo,
    logo_inverse: AppLogoInverse,
    landing: HomeImg
  },
  hospitalsantacruz: {
    logo_regular: AppLogoSantaCruz,
    logo_inverse: AppLogoSantaCruz,
    landing: HomeImg
  },
  prosalco: {
    logo_regular: AppLogoProsalco,
    logo_inverse: AppLogoProsalco,
    landing: HomeImg
  }
};

export const oculus_settings: ImplementationSettings = {
  colors: OCULUS_TENANT_COLORS.base,
  envs: {
    google_recaptcha: import.meta.env.VITE_RECAPTCHA_KEY,
    backend_url: import.meta.env.VITE_BACKEND_URL
  },
  logos: OCULUS_TENANT_IMAGES.base,
  workUnits: WorkUnits
};
